import 'reflect-metadata';
import { Container } from 'inversify';
import { httpApi } from '../../common/infra/http';
import { TaxHttpGateway } from './tax.http.gateway';
import { CalcTaxNFUseCase } from '../application/calc-tax-nf.use.case';

export const Registry = {
    AxiosAdapter: Symbol.for('AxiosAdapter'),
    TaxGateway: Symbol.for('TaxGateway'),
    CalcTaxNFUseCase: Symbol.for('CalcTaxNFUseCase')
};

export const container = new Container();

container.bind(Registry.AxiosAdapter).toConstantValue(httpApi);
container.bind(Registry.TaxGateway).toDynamicValue((context) => {
    return new TaxHttpGateway(context.container.get(Registry.AxiosAdapter));
});
container.bind(Registry.CalcTaxNFUseCase).toDynamicValue((context) => {
    return new CalcTaxNFUseCase(context.container.get(Registry.TaxGateway));
});

const tax = {
    calcTaxNF: container.get<CalcTaxNFUseCase>(Registry.CalcTaxNFUseCase)
};
export default tax;
